<template>
  <v-dialog v-model="visible" max-width="1100">
    <v-card class="order-detail-dialog">
      <v-card-title class="dialog-header">
        <div class="header-left">
          <span class="title-bar"></span>
          <span class="dialog-title-text">订单被保人清单</span>
        </div>
        <div class="header-right">
          <span class="status-badge" :class="getStatusClass(info.orderStatus !== undefined ? info.orderStatus : info.coverStatus)">
            {{ info.orderStatusStr || info.coverStatusStr }}
          </span>
          <v-btn icon small class="close-btn" @click="close">
            <v-icon small>close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="dialog-body">
        <!-- 订单基本信息 -->
        <div class="policy-info-section">
          <div class="info-row">
            <span class="info-item"><span class="label">投保单单号：</span>{{ info.insurerApplyPolicyNo }}</span>
            <span class="info-item"><span class="label">保单号：</span>{{ info.policyCode }}</span>
            <span class="info-item"><span class="label">投保人：</span>{{ info.policyholderName }}</span>
          </div>
          <div class="info-row">
            <span class="info-item"><span class="label">产品名称：</span><span class="highlight">{{ info.productName }}</span></span>
            <span class="info-item"><span class="label">保障期限：</span>{{ info.insureStartDate }} 至 {{ info.insureEndDate }}</span>
            <span class="info-item"><span class="label">保费（元）：</span>{{ info.premium }}</span>
            <span class="info-item"><span class="label">支付模式：</span>{{ getPayModeText(info) }}</span>
          </div>
          <div class="info-row">
            <span class="info-item"><span class="label">创建时间：</span>{{ info.createTime }}</span>
          </div>
        </div>

        <!-- 搜索和操作 -->
        <div class="search-section">
          <v-text-field
            v-model="searchName"
            placeholder="被保人姓名"
            outlined
            dense
            solo
            hide-details
            class="search-input"
          ></v-text-field>
          <v-text-field
            v-model="searchCertNo"
            placeholder="证件号码"
            outlined
            dense
            solo
            hide-details
            class="search-input"
          ></v-text-field>
          <v-btn color="#dd122a" small class="search-btn" @click="search">搜索</v-btn>
          <v-btn outlined color="#999" small class="reset-btn" @click="resetSearch">清空</v-btn>
          <v-btn outlined color="#dd122a" small class="export-btn" @click="exportList" :disabled="exporting">
            {{ exporting ? '导出中...' : '导出' }}
          </v-btn>
        </div>

        <!-- 被保人列表表格 -->
        <div class="person-table-wrapper">
          <div v-if="loading" class="loading-mask">
            <v-progress-circular indeterminate color="#dd122a"></v-progress-circular>
          </div>
          <table class="person-table" v-else>
            <thead>
              <tr>
                <th>被保人</th>
                <th>投保单号</th>
                <th>保单号</th>
                <th>投保单位</th>
                <th>企业信用代码</th>
                <th>产品名称</th>
                <th>保费（元）</th>
                <th>保单起期</th>
                <th>保单止期</th>
                <th>保单状态</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in list" :key="index">
                <td>{{ item.insuredName }}</td>
                <td>{{ item.insurerApplyPolicyNo }}</td>
                <td>{{ item.policyCode }}</td>
                <td>{{ item.policyholderName }}</td>
                <td>{{ item.policyholderCertNo }}</td>
                <td>{{ item.productName }}</td>
                <td>{{ item.premium }}</td>
                <td>{{ item.effectiveDate }}</td>
                <td>{{ item.expiryDate }}</td>
                <td>{{ item.coverStatusStr }}</td>
              </tr>
              <tr v-if="!loading && list.length === 0">
                <td colspan="10" class="empty-row">暂无被保人数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分页 -->
        <div class="dialog-pagination" v-if="totalPages > 1">
          <v-pagination
            v-model="currentPage"
            :length="totalPages"
            :total-visible="7"
            color="#dd122a"
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getOrderInsuredList, exportOrderInsuredList } from '@/api/travelInsurance';

export default {
  name: 'OrderDetailDialog',
  data() {
    return {
      visible: false,
      info: {},
      list: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
      loading: false,
      searchName: '',
      searchCertNo: '',
      exporting: false,
    };
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getList();
      }
    }
  },
  methods: {
    // 当前订单的订单ID
    getCurrentOrderId() {
      return this.info.orderId != null ? this.info.orderId : this.info.id;
    },

    close() {
      this.visible = false;
      this.info = {};
      this.list = [];
      this.currentPage = 1;
      this.searchName = '';
      this.searchCertNo = '';
    },

    open(orderInfo) {
      this.info = orderInfo || {};
      this.visible = true;
      this.currentPage = 1;
      this.searchName = '';
      this.searchCertNo = '';
      this.getList();
    },

    getList() {
      const orderId = this.getCurrentOrderId();
      if (orderId == null) {
        this.$message.error('缺少订单ID');
        return;
      }
      this.loading = true;
      const params = {
        id: Number(orderId),
        name: this.searchName,
        certNo: this.searchCertNo,
        pageIndex: this.currentPage,
        pageSize: this.pageSize
      };
      getOrderInsuredList(params).then(res => {
        if (res.code === 0 || res.success) {
          const pageData = res.data || {};
          this.list = pageData.records || [];
          this.totalCount = pageData.total || 0;
          this.totalPages = pageData.pages || 1;
        } else {
          this.$message.error(res.msg || '获取订单被保人列表失败');
          this.list = [];
        }
      }).catch(err => {
        console.error('获取订单被保人列表失败:', err);
        this.$message.error('获取订单被保人列表失败');
        this.list = [];
      }).finally(() => {
        this.loading = false;
      });
    },

    search() {
      this.currentPage = 1;
      this.getList();
    },

    resetSearch() {
      this.searchName = '';
      this.searchCertNo = '';
      this.currentPage = 1;
      this.getList();
    },

    exportList() {
      const orderId = this.getCurrentOrderId();
      if (orderId == null) {
        this.$message.error('缺少订单ID');
        return;
      }
      this.exporting = true;
      const params = {
        id: Number(orderId),
        name: this.searchName || undefined,
        certNo: this.searchCertNo || undefined
      };
      exportOrderInsuredList(params).then(res => {
        if (res && res.type === 'application/json') {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result);
              this.$message.error(err.msg || '导出失败');
            } catch (e) {
              this.$message.error('导出失败');
            }
          };
          reader.readAsText(res);
          return;
        }
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const fileName = this.info.insurerApplyPolicyNo || orderId;
        link.download = `订单被保人_${fileName}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }).catch(err => {
        console.error('导出被保人失败:', err);
        this.$message.error('导出被保人失败');
      }).finally(() => {
        this.exporting = false;
      });
    },

    // 订单状态：0待支付 1已取消 2待承保 3承保失败 4已承保 5已退保 6已退款
    getStatusClass(status) {
      const statusMap = {
        0: 'status-warning',
        1: 'status-canceled',
        2: 'status-pending',
        3: 'status-error',
        4: 'status-active',
        5: 'status-canceled',
        6: 'status-refunded'
      };
      return statusMap[status] || '';
    },

    // 支付模式文本映射：0非见费 1见费出单 2预缴费
    getPayModeText(info) {
      if (info.payModeStr) return info.payModeStr;
      const map = { 0: '非见费', 1: '见费出单', 2: '预缴费' };
      const v = info.payMode;
      if (v === undefined || v === null || v === '') return '-';
      return map[v] !== undefined ? map[v] : (map[Number(v)] !== undefined ? map[Number(v)] : v);
    }
  }
};
</script>

<style lang="scss" scoped>
.order-detail-dialog {
  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid #e8e8e8;

    .header-left {
      display: flex;
      align-items: center;
      gap: 8px;

      .title-bar {
        width: 4px;
        height: 16px;
        background-color: #dd122a;
        border-radius: 2px;
      }

      .dialog-title-text {
        font-size: 16px;
        font-weight: 500;
        color: #333;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 12px;

      .status-badge {
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;

        &.status-pending {
          background-color: #DBEAFE;
          color: #007DFF;
        }

        &.status-active {
          background-color: #DCFCE8;
          color: #18813E;
        }

        &.status-warning {
          background-color: #FFF7E6;
          color: #D46B08;
        }

        &.status-error {
          background-color: #FDF1F2;
          color: #DD122A;
        }

        &.status-canceled {
          background-color: #EEEEEE;
          color: #93969B;
        }

        &.status-refunded {
          background-color: #F0F0F0;
          color: #666666;
        }
      }

      .close-btn {
        width: 28px;
        height: 28px;

        .v-icon {
          color: #999;
          font-size: 18px;
        }

        &:hover .v-icon {
          color: #666;
        }
      }
    }
  }

  .dialog-body {
    padding: 20px 24px;

    .policy-info-section {
      margin-bottom: 20px;

      .info-row {
        display: flex;
        flex-wrap: wrap;
        gap: 40px;
        margin-bottom: 12px;

        .info-item {
          font-size: 14px;
          color: #262626;

          .label {
            color: #93969B;
          }

          .highlight {
            color: #dd122a;
          }
        }
      }
    }

    .search-section {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      margin-bottom: 16px;

      .search-input {
        width: 200px;
        margin-top: 0;
        padding-top: 0;

        ::v-deep .v-input__slot {
          min-height: 36px;
          height: 36px;
          border-radius: 4px;
        }

        ::v-deep .v-text-field--outlined fieldset {
          border-color: #dcdcdc;
        }

        ::v-deep input {
          padding-top: 0;
          padding-bottom: 0;
        }
      }

      .search-btn,
      .reset-btn,
      .export-btn {
        text-transform: none;
        font-weight: normal;
        height: 36px;
        margin-top: 0;
        color: #fff;
      }

      .search-btn {
        color: #fff;
      }
    }

    .person-table-wrapper {
      position: relative;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      overflow: hidden;
      margin-bottom: 16px;
      overflow-x: auto;
    }

    .person-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;

      thead {
        background-color: #F5F5F5;

        th {
          padding: 12px 8px;
          text-align: center;
          font-weight: 500;
          color: #333;
          border-bottom: 1px solid #e8e8e8;
          white-space: nowrap;
        }
      }

      tbody {
        tr {
          border-bottom: 1px solid #e8e8e8;

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            background-color: #fafafa;
          }

          td {
            padding: 12px 8px;
            text-align: center;
            vertical-align: middle;
            color: #333;
            white-space: nowrap;
          }

          .empty-row {
            color: #999;
            padding: 32px 8px;
          }
        }
      }
    }

    .dialog-pagination {
      display: flex;
      justify-content: flex-end;

      ::v-deep .v-pagination__item {
        font-size: 13px;
      }

      ::v-deep .v-pagination__navigation {
        i {
          font-size: 18px;
        }
      }
    }

    .loading-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
    }
  }
}
</style>